import { render, staticRenderFns } from "./Suspension.vue?vue&type=template&id=ebde008e&scoped=true&"
import script from "./Suspension.vue?vue&type=script&lang=js&"
export * from "./Suspension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebde008e",
  null
  
)

export default component.exports